var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo } from "react";
// icons
import MoneyWithHand from "@frameworks/shared-library/assets/images/features/Markets/Pms/money-with-hand.svg";
// stylesheet
import "../orderbook.scss";
// components
import { InfoAlert, InputComponent } from "../../../../components";
import { floatNumExp } from "@frameworks/web/utils/regex";
import EmpPartnerSearch from "../../../../components/EmpPartnerSearch";
import { useSelector } from "react-redux";
var ModifySubbroker = function (_a) {
    var _b, _c, _d;
    var onClickBack = _a.onClickBack, form = _a.form, setForm = _a.setForm;
    var orderBook = useSelector(function (state) { return state.markets.orderBook; }).orderBookDetails;
    var isPassoutAndSbCode = useMemo(function () {
        var _a, _b;
        return ((_a = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _a === void 0 ? void 0 : _a.passout) || ((_b = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _b === void 0 ? void 0 : _b.sbCode);
    }, [(_b = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _b === void 0 ? void 0 : _b.passout, (_c = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _c === void 0 ? void 0 : _c.sbCode]);
    var handleOnChangeInputs = function (name, value) {
        var parsedValue = value.trim();
        if (name === "passout_percent") {
            if (!isNaN(Number(parsedValue)) &&
                Number(parsedValue) >= 0 &&
                Number(parsedValue) <= 100) {
                setForm(__assign(__assign({}, form), { passout_percent: parsedValue }));
            }
        }
    };
    useEffect(function () {
        var _a, _b, _c;
        if (isPassoutAndSbCode) {
            setForm(__assign(__assign({}, form), { passout_percent: Number((_a = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _a === void 0 ? void 0 : _a.passout) === 0
                    ? null
                    : (_b = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _b === void 0 ? void 0 : _b.passout, passout_user_code: (_c = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _c === void 0 ? void 0 : _c.sbCode }));
        }
    }, [isPassoutAndSbCode]);
    return (React.createElement("div", { className: "modify-sub-broker-container" },
        React.createElement("div", { className: "top-header" },
            React.createElement("div", { className: "d-flex gap-2 align-items-center" },
                React.createElement("p", { className: "cursor-pointer", onClick: onClickBack },
                    React.createElement("i", { className: "edel-icon-left-arrow left-arrow" })),
                React.createElement("p", { className: "DMSanM_14_500 title" }, isPassoutAndSbCode
                    ? "Modify Sub Broker Details"
                    : "Add Sub Broker Details")),
            React.createElement(InfoAlert, { title: isPassoutAndSbCode
                    ? "You can update the payout % for SB only until the order is executed."
                    : "You can add SB details only within 60 days of placing the order.", className: "alert-container" }),
            React.createElement("div", { className: "form-container primary-aif-pms-sidebar-container bg-white" },
                ((_d = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _d === void 0 ? void 0 : _d.sbCode) ? (React.createElement(InputComponent, { label: "Sub Broker Name/Code", placeholder: "", helperText: "", value: form === null || form === void 0 ? void 0 : form.passout_user_code, disabled: true, className: "sub-broker-code" })) : (React.createElement(EmpPartnerSearch, { onSelectClient: function (data) {
                        setForm(__assign(__assign({}, form), { passout_user_code: data === null || data === void 0 ? void 0 : data.display_code, passout_user_type: data === null || data === void 0 ? void 0 : data.display_type }));
                    }, label: "Sub Broker Name/Code" })),
                React.createElement(InputComponent, { label: "Passout %", placeholder: "Enter Passout", helperText: "", name: "passout_percent", min: 1, max: 100, value: form.passout_percent, defaultValue: form.passout_percent, float: floatNumExp(2), onChangeEvent: function (event) {
                        var _a, _b;
                        var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                        handleOnChangeInputs("passout_percent", value);
                    } }))),
        React.createElement("div", { className: "image-container" },
            React.createElement("img", { src: MoneyWithHand, className: "" }))));
};
export default ModifySubbroker;
